'use es6';

import { createSelector } from 'reselect';
import { COUPON_CAMPAIGN_KEY } from 'AdsUI/data/HubAttributesData';
export const getHubAttributes = state => state.hubAttributes;
export const getPortalShouldSeeCouponBanner = createSelector(getHubAttributes, attributes => attributes.get(COUPON_CAMPAIGN_KEY, 'false'));